var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclaim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "bob-core-components-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icons/_tint/exclaim-"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1c5.8 0 10.45 4.65 10.55 10.5.05 5.556-4.446 10.241-9.968 10.539l-.282.011h-.25c-2.172 0-4.166-.669-5.855-1.796L5.4 20.05l-2.8 1.4c-.05.05-.15.05-.2.05-.275 0-.508-.252-.43-.525L2 20.9l1.35-2.8C1.7 16.05.8 13.4 1.05 10.5 1.5 5.55 5.5 1.55 10.4 1.05c.4-.05.75-.05 1.1-.05zm0 15c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-11c-.3 0-.5.2-.5.5v9c0 .267.158.454.404.493L11.5 15c.3 0 .5-.2.5-.5v-9c0-.267-.158-.454-.404-.493L11.5 5z",
    className: "primarytint"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclaim);
export default __webpack_public_path__ + "static/media/exclaim.6f551f3a130700db826597636c532d06.svg";
export { ForwardRef as ReactComponent };